import {
  Accordion,
  AccordionItem,
  Button,
  Drawer,
  Dropdown,
  Icon,
  IconButton,
  TextField,
  Typography,
  DatePicker,
} from "cfa-react-components";
import { Filter, Close } from "@cfa-icons/system";
import React, { useEffect, useState } from "react";
import { Col, Row } from "reactstrap";
import SelectSearch from "react-select-search";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllRefundAnalysisInformation,
  refundAnalysisFrcSelector,
} from "../../../redux/features/refundAnalysisSlice";
import { getOktaUser } from "../../../utils/LocalStorage";

const RiskInformationFilters: React.FC<any> = ({
  gridApi,
  loading,
  rowData,
  detailFilters,
}: any): JSX.Element => {
  const [locationNumber, setLocationNumber] = useState<string>("");
  const [modelProb, setModelProb] = useState<string>("");
  const [maxRiskScore, setMaxRiskScore] = useState<string>("");
  const [researchStatus, setResearchStatus] = useState<any>("");
  const [operatorEmailed, setOperatorEmailed] = useState<any>("");
  const [financialConsultant, setFinancialConsultant] = useState<any>("");
  const [rcma, setRcma] = useState<any>("");
  const [quickFilterTerm, setQuickFilterTerm] = useState("");
  const [startDate, setStartDate] = useState<any>(null);
  const [endDate, setEndDate] = useState<any>(null);
  const [refundType, setRefundType] = useState<any>("");

  const frcList = useSelector(refundAnalysisFrcSelector);

  const dispatch = useDispatch();
  const oktaUserInfo = getOktaUser();

  function clearAllFields() {
    let startDateRaw = new Date();
    startDateRaw.setDate(startDateRaw.getDate() - 30);
    const startDate = startDateRaw.toISOString().split("T")[0];

    let endDateRaw = new Date();
    endDateRaw.setDate(endDateRaw.getDate());
    const endDate = endDateRaw.toISOString().split("T")[0];

    const userEmail = oktaUserInfo[1];
    const params = { userEmail, startDate, endDate };
    dispatch(fetchAllRefundAnalysisInformation(params));

    gridApi.setQuickFilter("");
    gridApi.setFilterModel(null);
    setStartDate(null);
    setEndDate(null);
    setModelProb("");
    filterByRiskScore("");
    setResearchStatus("");
    setOperatorEmailed("");
    setMaxRiskScore("");
    filterByMaxRiskScore("");
    setLocationNumber("");
    setFinancialConsultant("");
    setRcma("");
    setQuickFilterTerm("");
    setRefundType("");
    detailFilters.length = 0;
    gridApi.onFilterChanged();
    gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
      detailGridInfo.api.setFilterModel(null);
      detailGridInfo.api.onFilterChanged();
    });
  }

  function filterByStartDate(newValue: any) {
    if (!isNaN(Date.parse(newValue))) {
      for (let i = 0; i < detailFilters.length; i++) {
        let obj = detailFilters[i];

        if (obj.field == "businessDate" && obj.type == "startDate") {
          detailFilters.splice(i, 1);
          i--;
        }
      }
      let trimmedDate = gridDateFormatter(newValue.toISOString());
      detailFilters.push({
        type: "startDate",
        field: "businessDate",
        model: trimmedDate,
      });
      let values: string[] = [];
      gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
        let filterInstance =
          detailGridInfo.api.getFilterInstance("businessDate");

        for (let row of rowData) {
          if (detailGridInfo.id.includes(row.locationNumber)) {
            for (let transaction of row.fsdmAnomalyScores) {
              if (transaction.businessDate >= trimmedDate) {
                values.indexOf(transaction.businessDate) === -1
                  ? values.push(transaction.businessDate)
                  : console.log("This item already exists");
              }
            }
          }
        }

        const model = {
          values: values,
          filterType: "set",
        };

        filterInstance.setModel(model);
        detailGridInfo.api.onFilterChanged();
      });
      for (let row of rowData) {
        for (let transaction of row.fsdmAnomalyScores) {
          if (transaction.businessDate >= trimmedDate) {
            values.indexOf(transaction.businessDate) === -1
              ? values.push(transaction.businessDate)
              : console.log("This item already exists");
          }
        }
      }
      const filterInstance = gridApi.getFilterInstance("minTransDate");
      filterInstance.setModel({
        values: values,
        filterType: "set",
      });
      gridApi.onFilterChanged();
    }
  }

  function filterByEndDate(newValue: any) {
    if (!isNaN(Date.parse(newValue))) {
      for (let i = 0; i < detailFilters.length; i++) {
        let obj = detailFilters[i];

        if (obj.field == "businessDate" && obj.type == "endDate") {
          detailFilters.splice(i, 1);
          i--;
        }
      }
      let trimmedDate = gridDateFormatter(newValue.toISOString());
      detailFilters.push({
        type: "endDate",
        field: "businessDate",
        model: trimmedDate,
      });
      let values: string[] = [];
      gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
        let filterInstance =
          detailGridInfo.api.getFilterInstance("businessDate");

        for (let row of rowData) {
          if (detailGridInfo.id.includes(row.locationNumber)) {
            for (let transaction of row.fsdmAnomalyScores) {
              if (transaction.businessDate <= trimmedDate) {
                values.indexOf(transaction.businessDate) === -1
                  ? values.push(transaction.businessDate)
                  : console.log("This item already exists");
              }
            }
          }
        }

        const model = {
          values: values,
          filterType: "set",
        };

        filterInstance.setModel(model);
        detailGridInfo.api.onFilterChanged();
      });
      for (let row of rowData) {
        for (let transaction of row.fsdmAnomalyScores) {
          if (transaction.businessDate <= trimmedDate) {
            values.indexOf(transaction.businessDate) === -1
              ? values.push(transaction.businessDate)
              : console.log("This item already exists");
          }
        }
      }
      const filterInstance = gridApi.getFilterInstance("maxTransDate");
      filterInstance.setModel({
        values: values,
        filterType: "set",
      });
      gridApi.onFilterChanged();
    }
  }

  function filterByResearchStatus(newValue: any) {
    let researchStatus: string = newValue;
    let researchStatusFilterValueSet: String[] = [];
    let filterType: String = "set";
    if (newValue === "Ranked") {
      researchStatusFilterValueSet = ["1", "2", "3", "4", "5"];
    } else if (newValue === "Unranked") {
      researchStatusFilterValueSet = ["0"];
    } else {
      researchStatusFilterValueSet = ["0", "1", "2", "3", "4", "5"];
    }
    for (let i = 0; i < detailFilters.length; i++) {
      let obj = detailFilters[i];

      if (obj.field == "refundAnomalyScoreRead.riskLevel") {
        detailFilters.splice(i, 1);
        i--;
      }
    }
    detailFilters.push({
      field: "refundAnomalyScoreRead.riskLevel",
      model: {
        values: researchStatusFilterValueSet,
        filterType: filterType,
      },
    });
    gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
      setResearchStatus(refundType);
      const detailFilterInstance = detailGridInfo.api.getFilterInstance(
        "refundAnomalyScoreRead.riskLevel"
      );
      detailFilterInstance.setModel({
        values: researchStatusFilterValueSet,
        filterType: filterType,
      });
      detailGridInfo.api.onFilterChanged();
    });
    const filterInstance = gridApi.getFilterInstance("ranked");
    if (researchStatus == "All") {
      filterInstance.setModel(null);
    } else {
      filterInstance.setModel({
        filter: researchStatus,
        filterType: "text",
        type: "contains",
      });
    }
    gridApi.onFilterChanged();
    gridApi.redrawRows();
  }

  function filterByOperatorEmailed(newValue: any) {
    let operatorEmailedFilterValueSet: String[] = [];
    let filterType: String = "set";
    if (newValue === "Sent") {
      operatorEmailedFilterValueSet = ["true"];
    } else if (newValue === "Unsent") {
      operatorEmailedFilterValueSet = ["false"];
    } else {
      operatorEmailedFilterValueSet = ["true", "false"];
    }
    for (let i = 0; i < detailFilters.length; i++) {
      let obj = detailFilters[i];

      if (obj.field == "hasEmailedOperator") {
        detailFilters.splice(i, 1);
        i--;
      }
    }
    detailFilters.push({
      field: "hasEmailedOperator",
      model: {
        values: operatorEmailedFilterValueSet,
        filterType: filterType,
      },
    });
    gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
      setOperatorEmailed(refundType);
      const detailFilterInstance =
        detailGridInfo.api.getFilterInstance("hasEmailedOperator");
      detailFilterInstance.setModel({
        values: operatorEmailedFilterValueSet,
        filterType: filterType,
      });
      detailGridInfo.api.onFilterChanged();
    });

    const filterInstance1 = gridApi.getFilterInstance("hasEmailedTransactions");
    const filterInstance2 = gridApi.getFilterInstance(
      "hasUnEmailedTransactions"
    );
    if (newValue === "Sent") {
      filterInstance2.setModel(null);
      filterInstance1.setModel({
        values: ["true"],
        filterType: filterType,
      });
    } else if (newValue === "Unsent") {
      filterInstance1.setModel(null);
      filterInstance2.setModel({
        values: ["true"],
        filterType: filterType,
      });
    } else {
      filterInstance2.setModel(null);
      filterInstance1.setModel(null);
    }
    gridApi.onFilterChanged();
    gridApi.redrawRows();
  }

  const filterByFinancialConsultant = (newValue: any) => {
    let searchString: number = newValue.target.value;
    setFinancialConsultant(newValue.target.value);
    const filterInstance = gridApi.getFilterInstance("financialConsultant");
    filterInstance.setModel({
      filter: searchString,
      filterType: "text",
      type: "contains",
    });
    gridApi.onFilterChanged();
  };

  const filterByRcma = (newValue: any) => {
    let searchString: number = newValue.target.value;
    setRcma(newValue.target.value);
    const filterInstance = gridApi.getFilterInstance("rcma");
    filterInstance.setModel({
      filter: searchString,
      filterType: "text",
      type: "contains",
    });
    gridApi.onFilterChanged();
  };

  function gridDateFormatter(date: string) {
    if (date == null) {
      return "";
    }
    if (date.indexOf("T") == -1) {
      return date;
    }
    if (date.length != 0) {
      date = date.slice(0, date.indexOf("T"));
      return date;
    } else {
      return "";
    }
  }

  const filterByLocationNumber = (newValue: any) => {
    let locationNum: number = newValue.target.value;
    setLocationNumber(newValue.target.value);
    const filterInstance = gridApi.getFilterInstance("locationNumber");
    filterInstance.setModel({
      filter: locationNum,
      filterType: "number",
      type: "lessThanOrEqual",
    });
    gridApi.onFilterChanged();
  };

  const filterByMaxRiskScore = (newValue: any) => {
    if (newValue == ".") {
      setMaxRiskScore(newValue);
      return;
    }
    for (let i = 0; i < detailFilters.length; i++) {
      let obj = detailFilters[i];

      if (obj.field == "modelProb") {
        detailFilters.splice(i, 1);
        i--;
      }
    }
    let riskScore: number = newValue;
    detailFilters.push({
      field: "modelProb",
      model: {
        filter: riskScore,
        filterType: "number",
        type: "greaterThanOrEqual",
      },
    });
    if (gridApi) {
      gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
        const detailFilterInstance =
          detailGridInfo.api.getFilterInstance("modelProb");
        detailFilterInstance.setModel({
          filter: riskScore,
          filterType: "number",
          type: "greaterThanOrEqual",
        });
        detailGridInfo.api.onFilterChanged();
      });
      let maxRiskScore: number = newValue;
      setMaxRiskScore(newValue);
      const filterInstance = gridApi.getFilterInstance("modelProb");
      filterInstance.setModel({
        filter: maxRiskScore,
        filterType: "number",
        type: "greaterThanOrEqual",
      });
      gridApi.onFilterChanged();
      gridApi.redrawRows();
    }
  };

  function filterByRiskScore(newValue: any) {
    if (newValue == ".") {
      setModelProb(newValue);
      return;
    }
    for (let i = 0; i < detailFilters.length; i++) {
      let obj = detailFilters[i];

      if (obj.field == "modelProb") {
        detailFilters.splice(i, 1);
        i--;
      }
    }
    let riskScore: number = newValue;
    detailFilters.push({
      field: "modelProb",
      model: {
        filter: riskScore,
        filterType: "number",
        type: "greaterThanOrEqual",
      },
    });
    setModelProb(newValue);
    gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
      const detailFilterInstance =
        detailGridInfo.api.getFilterInstance("modelProb");
      detailFilterInstance.setModel({
        filter: riskScore,
        filterType: "number",
        type: "greaterThanOrEqual",
      });
      detailGridInfo.api.onFilterChanged();
    });
    let maxRiskScore: number = newValue;
    const filterInstance = gridApi.getFilterInstance("modelProb");
    filterInstance.setModel({
      filter: maxRiskScore,
      filterType: "number",
      type: "greaterThanOrEqual",
    });
    gridApi.onFilterChanged();
    gridApi.redrawRows();
  }

  function filterByRefundType(newValue: any) {
    let refundType: string = newValue;
    for (let i = 0; i < detailFilters.length; i++) {
      let obj = detailFilters[i];

      if (obj.field == "refundType") {
        detailFilters.splice(i, 1);
        i--;
      }
    }
    if (refundType !== "All") {
      detailFilters.push({
        field: "refundType",
        model: {
          filter: refundType,
          filterType: "string",
          type: "text",
        },
      });
    }
    gridApi.forEachDetailGridInfo((detailGridInfo: any) => {
      setRefundType(refundType);
      const detailFilterInstance =
        detailGridInfo.api.getFilterInstance("refundType");
      if (refundType === "All") {
        detailFilterInstance.setModel(null);
      } else {
        detailFilterInstance.setModel({
          filter: refundType,
          filterType: "string",
          type: "text",
        });
      }
      detailGridInfo.api.onFilterChanged();
    });
    const filterInstance = gridApi.getFilterInstance("refundType");
    if (refundType == "All") {
      filterInstance.setModel(null);
    } else {
      filterInstance.setModel({
        filter: refundType,
        filterType: "text",
        type: "contains",
      });
    }
    gridApi.onFilterChanged();
    gridApi.redrawRows();
  }

  const generalSearch = (newValue: any) => {
    setQuickFilterTerm(newValue.target.value);
    gridApi.setQuickFilter(newValue.target.value);
  };

  const [drawer, setDrawer] = useState(false);

  const disableFutureDates = (current: Date) => {
    const start = new Date();
    start.setHours(0, 0, 0, 0);

    return current > start;
  };

  return (
    <>
      <Drawer
        anchor="right"
        content={
          <div style={{ padding: "4" }}>
            <IconButton
              aria-label="close"
              color="default"
              onClick={() => setDrawer(false)}
              size="xs"
            >
              <Icon icon={Close} />
            </IconButton>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                padding: 4,
              }}
            >
              <Row>
                <Col>
                  <Typography
                    gutterBottom
                    variant="h2"
                    style={{ marginLeft: "1rem" }}
                  >
                    Filters
                  </Typography>
                </Col>
                <Col>
                  <Button
                    variant={"outlined"}
                    size={"sm"}
                    color={"secondary"}
                    style={{ justifySelf: "flex-end" }}
                    onClick={clearAllFields}
                  >
                    Clear All
                  </Button>{" "}
                </Col>
              </Row>
              <Accordion
                enableMultipleOpen={true}
                iconPosition="end"
                variant="default"
                defaultActiveItemKey={["0", "1", "2", "3", "4", "5", "6"]}
              >
                <AccordionItem header="General" itemKey="0">
                  <TextField
                    compact
                    errorText=""
                    helperText=""
                    label="General Search"
                    onChange={(newValue) => generalSearch(newValue)}
                    placeholder="Search..."
                    successText=""
                    value={quickFilterTerm}
                  />
                </AccordionItem>
                <AccordionItem header="Location" itemKey="1">
                  <TextField
                    compact
                    errorText=""
                    helperText=""
                    // label="Location"
                    onChange={(newValue) => {
                      filterByLocationNumber(newValue);
                    }}
                    placeholder="Filter Location Numbers"
                    successText=""
                    value={locationNumber}
                  />
                </AccordionItem>
                <AccordionItem header="Risk Probabilty" itemKey="2">
                  <TextField
                    compact
                    errorText=""
                    helperText=""
                    label="Filter Max Risk Probability"
                    onChange={
                      (newValue) => filterByMaxRiskScore(newValue.target.value)
                      //setMaxRiskScore(newValue.target.value)
                    }
                    placeholder="Set High Risk Threshold"
                    successText=""
                    value={maxRiskScore}
                  />
                </AccordionItem>
                <AccordionItem header="Research Status" itemKey="3">
                  <Dropdown
                    compact
                    errorText=""
                    label="Filter Research Status"
                    onChange={(newValue) => {
                      filterByResearchStatus(newValue);
                      setResearchStatus(newValue);
                    }}
                    options={["All", "Ranked", "Unranked"]}
                    placeholder="Select Research Status"
                    successText=""
                    value={researchStatus}
                  />
                  <Dropdown
                    compact
                    errorText=""
                    label="Filter Emailed Operator"
                    onChange={(newValue) => {
                      filterByOperatorEmailed(newValue);
                      setOperatorEmailed(newValue);
                    }}
                    options={["All", "Sent", "Unsent"]}
                    placeholder="Select Email Status"
                    successText=""
                    value={operatorEmailed}
                  />
                </AccordionItem>

                <AccordionItem header="Refund Type" itemKey="4">
                  <Dropdown
                    compact
                    errorText=""
                    label="Filter Refund Type"
                    onChange={(newValue) => {
                      filterByRefundType(newValue);
                      setRefundType(newValue);
                    }}
                    options={["All", "Cash", "Credit"]}
                    placeholder="Select Refund Type"
                    successText=""
                    value={refundType}
                  />
                </AccordionItem>

                <AccordionItem header="Financial Risk Consultant" itemKey="5">
                  <TextField
                    compact
                    errorText=""
                    helperText=""
                    onChange={(newValue) => {
                      filterByFinancialConsultant(newValue);
                    }}
                    placeholder="Filter FRC"
                    successText=""
                    value={financialConsultant}
                  />
                </AccordionItem>
                <AccordionItem header="RCMA" itemKey="5">
                  <TextField
                    compact
                    errorText=""
                    helperText=""
                    onChange={(newValue) => {
                      filterByRcma(newValue);
                    }}
                    placeholder="Filter RCMA"
                    successText=""
                    value={rcma}
                  />
                </AccordionItem>
                <AccordionItem header="Business Dates" itemKey="6">
                  <Row
                    style={{
                      display: "flex",
                      marginBottom: "1rem",
                      justifyContent: "right",
                    }}
                  >
                    <Typography style={{ display: "flex", marginRight: "9%" }}>
                      Start Date:
                    </Typography>
                    <DatePicker
                      disabledDates={disableFutureDates}
                      compact
                      errorText=""
                      helperText=""
                      label=""
                      locale="en-US"
                      onChange={(newValue) => {
                        // @ts-ignore
                        const startDate = newValue.toISOString().split("T")[0];

                        let endDateRaw = new Date();
                        endDateRaw.setDate(endDateRaw.getDate());
                        let endDate = endDateRaw.toISOString().split("T")[0];
                        if (detailFilters.length !== 0) {
                          console.log("there are filters!");

                          for (let i = 0; i < detailFilters.length; i++) {
                            let obj = detailFilters[i];

                            if (
                              obj.field == "businessDate" &&
                              obj.type == "endDate"
                            ) {
                              endDate = obj.model;
                            }
                          }
                        }

                        const userEmail = oktaUserInfo[1];
                        const params = { userEmail, startDate, endDate };
                        dispatch(fetchAllRefundAnalysisInformation(params));
                        setStartDate(newValue);
                        filterByStartDate(newValue);
                      }}
                      placeholder=""
                      successText=""
                      style={{ width: "50%", marginRight: "auto" }}
                      value={startDate}
                    />
                  </Row>
                  <Row style={{ display: "flex", justifyContent: "right" }}>
                    <Typography
                      style={{ display: "flex", marginRight: "1rem" }}
                    >
                      End Date:
                    </Typography>
                    <DatePicker
                      disabledDates={disableFutureDates}
                      compact
                      errorText=""
                      helperText=""
                      label=""
                      locale="en-US"
                      onChange={(newValue) => {
                        // @ts-ignore
                        const endDate = newValue.toISOString().split("T")[0];

                        let startDateRaw = new Date();
                        startDateRaw.setDate(startDateRaw.getDate());
                        let startDate = startDateRaw
                          .toISOString()
                          .split("T")[0];
                        if (detailFilters.length !== 0) {
                          console.log("there are filters!");

                          for (let i = 0; i < detailFilters.length; i++) {
                            let obj = detailFilters[i];

                            if (
                              obj.field == "businessDate" &&
                              obj.type == "startDate"
                            ) {
                              startDate = obj.model;
                            }
                          }
                        }

                        const userEmail = oktaUserInfo[1];
                        const params = { userEmail, startDate, endDate };
                        dispatch(fetchAllRefundAnalysisInformation(params));
                        setEndDate(newValue);
                        filterByEndDate(newValue);
                      }}
                      placeholder=""
                      successText=""
                      style={{ width: "50%", marginRight: "auto" }}
                      value={endDate}
                    />
                  </Row>
                </AccordionItem>
              </Accordion>
            </div>
          </div>
        }
        elevation={4}
        onClose={function noRefCheck() {}}
        onEnter={function noRefCheck() {}}
        onExit={function noRefCheck() {}}
        variant="temporary"
        width="narrow"
        hideBackdrop={true}
        open={drawer}
        style={{ alignSelf: "right" }}
      />
      <div style={{ justifyContent: "right", textAlign: "right" }}>
        <Button
          onClick={() => setDrawer(true)}
          size="md"
          variant="outlined"
          loading={loading}
        >
          <Icon icon={Filter} />
          Filters
        </Button>
      </div>
    </>
  );
};
export default RiskInformationFilters;
